import { AuthService } from "@js/services/AuthService";
import { SharedCriteriaService } from "@js/services/Deal/SharedCriteriaService";
import { OrganisationService } from "@js/services/OrganisationService";
import { RoleService } from "@js/services/RoleService";
import { UserService } from "@js/services/UserService";
import {
  BrickflowEventLogClient,
  LenderClient,
  LinkTypeEnum,
  Organisation,
  OrganisationClient,
  OrganisationLink,
  OrganisationLinkClient,
  ProductFamilyEnum,
  ProductTypeEnum,
  StaticDataClient,
  UserClient,
} from "@src/apis/ModularClient";

export class AllLoansLandingController {
  isLoggedInUser: boolean = false;
  totalLenders: number = 0;
  isBorrower: boolean = false;
  orgCode: string | null;
  organisationLink: OrganisationLink;
  previewContent: boolean = false;
  organisation: Organisation;

  //error message to enterprise client when organisation does not have a valid permission
  noPermissionErrorMsg: string = "";
  dataLoading: boolean = false;

  isCommercialOwnerOccupiedActive: boolean = false;

  showHelpModal: boolean = false;
  headerProductFamily: ProductFamilyEnum = ProductFamilyEnum.None;
  enterpriseLinkLogo: string;
  showBridgingOption: boolean = false;
  showCommercialOption: boolean = false;
  showDevFinaceOption: boolean = true;
  isBridgingDisabled: boolean = false;
  isCommercialDisabled: boolean = false;

  isWidget: boolean = false;
  showCriteriaSection: boolean = false;
  isMobileView: boolean = false;

  productFamilyType = ProductFamilyEnum.None;

  static $inject = [
    "$scope",
    "$routeParams",
    "$cookies",
    "$location",
    "$q",
    "AuthService",
    "OrganisationClient",
    "LenderClient",
    "BrickflowEventLogClient",
    "OrganisationLinkClient",
    "SharedCriteriaService",
    "UserClient",
    "$rootScope",
    "OrganisationService",
    "StaticDataClient",
    "RoleService",
    "UserService",
  ];

  constructor(
    private $scope: ng.IScope,
    private $routeParams: ng.route.IRouteParamsService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    protected $q: ng.IQService,
    private $auth: AuthService,
    private organisationClient: OrganisationClient,
    private lenderClient: LenderClient,
    private eventLogClient: BrickflowEventLogClient,
    private organisationLinkClient: OrganisationLinkClient,
    private sharedCriteriaService: SharedCriteriaService,
    private userClient: UserClient,
    public $rootScope: ng.IRootScopeService,
    private organisationService: OrganisationService,
    private staticDataClient: StaticDataClient,
    public roleService: RoleService,
    public userService: UserService,
  ) {
    if (window.self == window.top) {
      this.orgCode = this.$cookies.get("org_code");
    } else {
      this.orgCode = location.pathname.replace("/", "");
    }

    if ($cookies.get("access_token")) {
      this.roleService.isClientUser().then((isClient: boolean) => {
        if (this.orgCode && this.orgCode != "undefined" && this.orgCode != "") {
          this.userService.GetDefaultBrokerOrganisation().then((userDefaultBrokerOrg: Organisation) => {
            if (userDefaultBrokerOrg && userDefaultBrokerOrg.organisationCode != this.orgCode) {
              let broadcastResult = this.$rootScope.$broadcast("logout");

              if (broadcastResult.defaultPrevented) return;

              this.$auth.logout(false);
              window.location.reload();
            }
          });
        }
      });
    }

    if (!$cookies.get("access_token") && this.$routeParams.linkType)
      this.productFamilyType = this.getProductFamilyByLinkType();

    if (this.productFamilyType == ProductFamilyEnum.None || this.productFamilyType == ProductFamilyEnum.Commercial) {
      this.staticDataClient.isCommercialOwnerOccupiedActive().then((response) => {
        this.isCommercialOwnerOccupiedActive = response;
      });
    }

    if (this.$routeParams.context == "widget") {
      if (window.self != window.top) {
        if (!(this.$rootScope as any).previousRoute.startsWith("/e/enterpriseleadcapture")) {
          this.organisationService.sendDataToParent("height", "170px");
        }
        this.isWidget = true;
      } else {
        this.noPermissionErrorMsg =
          "This URL is designed to be embedded into a site, as a widget. If you would like the user to access this search directly, please use an Enterpise link.";
      }
    } else if (window.innerWidth <= 480 && window.self == window.top) {
      this.isMobileView = true;
    }

    if ($cookies.get("access_token")) {
      this.isLoggedInUser = true;
      this.setProductButtonStateAndVisibility();
    } else if (this.$location.path().startsWith("/allloans") && !$cookies.get("access_token")) {
      this.sharedCriteriaService.storeEnterpriseLinkType(
        this.$routeParams.linkType ? this.$routeParams.linkType.toString() : LinkTypeEnum.AllLoans.toString(),
      );

      this.organisationClient
        .getOrgByUrlIfOrgHasEnterpriseSearchPermission(
          this.orgCode ?? null,
          this.productFamilyType,
          this.$routeParams.linkId ?? null,
        )
        .then((response) => {
          if (response) {
            this.organisation = response;
            this.getNumberOfLenders(this.organisation.id);
            this.orgCode = response.organisationCode;
            this.showBridgingOption = response.hasBridging;
            this.showCommercialOption = response.hasCommercialMortgage;

            if ((this.isWidget && this.organisation.hasWidget) || !this.isWidget) {
              if (
                !this.isWidget ||
                ((this.$rootScope as any).previousRoute.startsWith("/e/enterpriseleadcapture") && this.isWidget)
              )
                this.selectDefaultProductFamily();
              this.logEvent();
              var imgs = document.getElementsByTagName("img");

              if (this.$routeParams.linkId && this.$routeParams.linkId != "0") {
                this.organisationLinkClient
                  .getOrganisationLinkLogoByLinkIdAndLogPageLoadEvent(
                    this.$routeParams.linkId,
                    "",
                    0,
                    ProductTypeEnum.None,
                    "",
                    0,
                  )
                  .then((logoUrl) => {
                    if (logoUrl) imgs[0].src = this.enterpriseLinkLogo = logoUrl;
                  });
              } else {
                this.enterpriseLinkLogo = imgs[0].src;
              }
            } else {
              this.organisationClient.findOrganisationAdminByOrgCode(this.orgCode).then((admin) => {
                this.noPermissionErrorMsg = admin
                  ? `We are unable to compare loans right now. Please contact your broker: ${admin.email}.`
                  : "We are unable to compare loans right now.  Please contact your broker.";
              });
            }
          } else {
            this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
          }
        });
    }

    //This event is added to navigate user to devfinance critera on click of devfinance link from helper text, when user is on Bare Land path for purchase/refinance search.
    let productFamilySelectionUnregister = $scope.$on("productFamilySelection", (event: ng.IAngularEvent, newValue) => {
      this.updateProdcutFamilyOption(newValue);
    });

    $scope.$on("$destroy", productFamilySelectionUnregister);
  }

  getNumberOfLenders(orgId) {
    this.lenderClient.getTotalLenders(ProductFamilyEnum.None, orgId).then((totalLenders: number) => {
      this.totalLenders = Math.floor(totalLenders / 5) * 5;
    });
  }

  updateProdcutFamilyOption(val) {
    this.headerProductFamily = val;
  }

  async initialRegisterEventLog(orgCode, organisationLinkId = null) {
    if (window.self == window.top) {
      if (sessionStorage.getItem("clientId")) {
        this.eventLogClient.logPageLoad(
          "ALLLOANS",
          orgCode,
          "",
          "Client",
          organisationLinkId,
          ProductTypeEnum.None,
          undefined,
          undefined,
          parseInt(sessionStorage.getItem("clientId")),
        );
      } else {
        this.eventLogClient.logPageLoad("ALLLOANS", orgCode, "", "Client", organisationLinkId, ProductTypeEnum.None);
      }
    } else {
      var clientId: number = null;
      clientId = Number(this.organisationService.getData("clientId"));
      if (clientId) {
        this.eventLogClient.logPageLoad(
          this.productFamilyType == ProductFamilyEnum.None
            ? "ALLLOANS"
            : `${this.getProducFamilyText().toUpperCase()}ALLLOANS`,
          orgCode,
          "",
          "Client",
          organisationLinkId,
          ProductTypeEnum.None,
          undefined,
          undefined,
          clientId,
        );
      } else {
        this.eventLogClient.logPageLoad(
          this.productFamilyType == ProductFamilyEnum.None
            ? "ALLLOANS"
            : `${this.getProducFamilyText().toUpperCase()}ALLLOANS`,
          orgCode,
          "",
          "Client",
          organisationLinkId,
          ProductTypeEnum.None,
        );
      }
    }
  }

  logEvent() {
    if (this.$routeParams.linkId) {
      if (this.orgCode) {
        this.initialRegisterEventLog(this.orgCode, Number(this.$routeParams.linkId));
      } else {
        this.initialRegisterEventLog("", Number(this.$routeParams.linkId));
      }
    } else {
      if (this.orgCode) {
        this.initialRegisterEventLog(this.orgCode);
      } else {
        this.initialRegisterEventLog("");
      }
    }
  }

  onClickShowHelpModal() {
    this.showHelpModal = true;
    if (this.isWidget && !this.showCriteriaSection) this.organisationService.sendDataToParent("height", "745px");
  }

  closeHelpModal() {
    if (this.isWidget && !this.showCriteriaSection) this.organisationService.sendDataToParent("height", "170px");
    this.showHelpModal = false;
  }

  selectDefaultProductFamily() {
    if (
      this.showBridgingOption &&
      !this.isBridgingDisabled &&
      (this.productFamilyType == ProductFamilyEnum.None || this.productFamilyType == ProductFamilyEnum.Bridging)
    ) {
      this.headerProductFamily = ProductFamilyEnum.Bridging;
    } else if (
      this.showCommercialOption &&
      !this.isCommercialDisabled &&
      (this.productFamilyType == ProductFamilyEnum.None || this.productFamilyType == ProductFamilyEnum.Commercial)
    ) {
      this.headerProductFamily = ProductFamilyEnum.Commercial;
    } else {
      this.headerProductFamily = ProductFamilyEnum.Development;
    }
    this.showCriteriaSection = true;
  }

  setProductButtonStateAndVisibility() {
    this.userClient.getCurrentUserPermissionForProductSearch().then((response) => {
      if (response) {
        if (response.isLender) {
          this.showBridgingOption = response.hasBridgingSearchPermission;
          this.showDevFinaceOption = response.hasDevFinanceSearchPermission;
          this.showCommercialOption = response.hasCommercialSearchPermission;
        } else {
          this.isBridgingDisabled = !response.hasBridgingSearchPermission;
          this.isCommercialDisabled = !response.hasCommercialSearchPermission;
          this.showBridgingOption = true;
          this.showDevFinaceOption = true;
          this.showCommercialOption = true;
        }
        this.getNumberOfLenders(response.orgId);
        this.selectDefaultProductFamily();
      } else {
        //This is to navigate a user to userdashboard when they try to access path directly
        this.$location.path("/userdashboard");
      }
    });
  }

  showorHideCriteriaSection() {
    if (this.showCriteriaSection) {
      this.organisationService.sendDataToParent("height", "170px");
    }
    this.showCriteriaSection = !this.showCriteriaSection;
  }

  footerSignInClicked() {
    var baseUrl = window.location.href.split("#!")[0] + "#!";
    var newUrl = `${baseUrl}/login`;
    window.open(newUrl, "_blank");
  }

  getProductFamilyByLinkType() {
    let productFamilyType = ProductFamilyEnum.None;
    switch (Number(this.$routeParams.linkType)) {
      case LinkTypeEnum.Development:
        productFamilyType = ProductFamilyEnum.Development;
        break;
      case LinkTypeEnum.Bridging:
        productFamilyType = ProductFamilyEnum.Bridging;
        break;
      case LinkTypeEnum.Commercial:
        productFamilyType = ProductFamilyEnum.Commercial;
        break;
      default:
        break;
    }
    return productFamilyType;
  }

  onStartSearchButtonClick() {
    switch (this.productFamilyType) {
      case ProductFamilyEnum.Development:
        this.headerProductFamily = ProductFamilyEnum.Development;
        break;
      case ProductFamilyEnum.Bridging:
        this.headerProductFamily = ProductFamilyEnum.Bridging;
        break;
      case ProductFamilyEnum.Commercial:
        this.headerProductFamily = ProductFamilyEnum.Commercial;
        break;
      default:
        break;
    }
    this.showCriteriaSection = true;
  }

  getProducFamilyText() {
    switch (this.productFamilyType) {
      case ProductFamilyEnum.Development:
        return "Development";
      case ProductFamilyEnum.Bridging:
        return "Bridging";
      case ProductFamilyEnum.Commercial:
        return "Commercial";
      default:
        return "";
    }
  }
}
